import { render, staticRenderFns } from "./reference-main.vue?vue&type=template&id=29b3de0e&"
import script from "./reference-main.vue?vue&type=script&lang=js&"
export * from "./reference-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports